import React from "react";
import { withTranslation } from "react-i18next";
import "./RiskPriority.scss";
import { BsFillSquareFill } from "react-icons/bs";

function RiskPriority({ t, riskPriority, isDashboardView }) {
  return (
    <>{
      isDashboardView
        ?
        <div className="Sc-Total_supplierBox_Risk">
          <table className="table table-hover">
            <thead>
              <tr>
                <th>Risk Categories</th>
                <th className="text-end">No.of Suppliers</th>
              </tr>
            </thead>
            <tbody>
              {
                riskPriority?.countByCategory?.map((item) => (
                  <tr key={item?.riskCategory?.id}>
                    <td style={{ color: item?.riskCategory?.colorCode }}>
                      <BsFillSquareFill  className="me-2"/>
                      {item?.riskCategory?.resultType}
                    </td>
                    <td className="text-end"><strong>{item?.count}</strong></td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
        :
        <div className="col-lg-5 p-2">
          <div className="card">
            <div className="card-body">
              <h6>{t("RiskPriority.label")}</h6>
              <div className="Riskpriority_status_count">
                <ul>
                  {riskPriority?.countByCategory?.map((item) => (
                    <li key={item?.riskCategory?.id}>
                      <span style={{ color: item?.riskCategory?.colorCode }}>{item?.riskCategory?.resultType}</span>
                      <h4 className="m-0">{item?.count}</h4>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
    }</>
  );
}

export default withTranslation()(RiskPriority);
